import { Controller } from '@hotwired/stimulus';
import { Turbo } from "@hotwired/turbo-rails"
import { useEventListener } from 'stimulus-library'
import { post } from '@rails/request.js'

export default class SidebarController extends Controller {
  static values = {
    expandPath: String,
    collapsePath: String,
  }

  connect() {
    useEventListener(this, this.element, 'sl-show', this.expandGroup)
    useEventListener(this, this.element, 'sl-hide', this.closeGroup)
  }

  async expandGroup(event) {
    if (!this.groupExpansionAllowed() || !this.hasExpandPathValue) {
      return
    }
    const target = event.target.dataset['target'];
    await post(this.expandPathValue, { body: { target } })
  }

  async closeGroup(event) {
    if (!this.groupExpansionAllowed() || !this.hasCollapsePathValue ) {
      return
    }
    const target = event.target.dataset['target'];
    await post(this.collapsePathValue, { body: { target } })
  }

  toggle() {
    this.element.classList.toggle('sidebar--drawer')
    this.element.classList.toggle('sidebar--rail')
    Turbo.cache.clear()
  }

  groupExpansionAllowed() {
    return this.element.classList.contains('sidebar--drawer');
  }
}